import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button } from '@mui/material';

const PaymentFailure = ({ onRetry }) => {
  return (
    <div style={{
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '2rem'
    }}>
      <h2 style={{
        fontFamily: 'Mulish',
        fontWeight: 700,
        fontSize: '22px',
        lineHeight: '100%',
        color: '#FF0000'
      }}>
        Payment Failed
      </h2>

      <div style={{
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        backgroundColor: '#ffe5e5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <CancelIcon style={{ fontSize: '60px', color: '#FF0000' }} />
      </div>

      <Button
        variant="outlined"
        onClick={onRetry}
        style={{
          width: '160px',
          height: '56px',
          borderRadius: '16px',
          borderColor: '#FF0000',
          color: '#FF0000',
          fontWeight: 600,
          fontFamily: 'Mulish'
        }}
      >
        Go Back
      </Button>
    </div>
  );
};

export default PaymentFailure;
